import React from "react";
import { CURRENCY_SYMBOL } from "../../../constant";
import LoadingIcon from "../../../components/Loading/LoadingIcon";
import { useSelector } from "react-redux";
import MyBalance from "../../../utils/myBalance";

const Balance = ({ className }) => {
  const memberData = useSelector((state) => state.isMemberInfo);

  return (
    <p
      className={`text-xl font-semibold mb-0 flex gap-[5px] items-center ${className}`}
    >
      <LoadingIcon>
        <MyBalance />
      </LoadingIcon>
      <span className="ml-[0px]">{CURRENCY_SYMBOL}</span>
    </p>
  );
};

export default Balance;
